import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Dashboard from "../../components/Dashboard";

const ProtectedRoutes = ({ children }) => {
  // Get auth state from Redux
  const isAuthenticated = useSelector((state) => !!state.user.loginData);

  // Optional: get loginData if needed later
  // const loginData = useSelector((state) => state.user.loginData);

  return isAuthenticated ? (
    <Dashboard>{children}</Dashboard>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoutes;
